import type { DefaultError } from '@tanstack/react-query'

// TanStack Query's own default. A retry function is otherwise unbounded, so a 5xx would spin forever.
const MAX_RETRIES = 3

export function retryOnNonUserError<TError = DefaultError>(failureCount: number, error: TError) {
  const status = error['status'] ?? 0
  const isUserError = status >= 400 && status < 500
  return !isUserError && failureCount < MAX_RETRIES
}
